import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, Observable, tap } from 'rxjs';
import {
  StateCreateRequestDTO,
  StateDeleteRequestDTO,
  StateDTO,
  StateList,
  StateReadByIdRequestDTO,
  StateReadByCountryIdRequestDTO,
  StateUpdateRequestDTO
} from './state.interface';
import {
  State_create,
  State_delete,
  State_readById,
  State_update,
  State_readByCountryId,
  State_readAll
} from 'src/app/GlobalVariables';

@Injectable({
  providedIn: 'root'
})
export class StateService {

  constructor() { }

  http = inject(HttpClient);
  states$ = new BehaviorSubject<StateDTO[]>([])
  State_create(data: StateCreateRequestDTO): Observable<StateDTO> {
    return this.http.post<StateDTO>(State_create, data);
  }

  State_update(data: StateUpdateRequestDTO): Observable<StateDTO> {
    return this.http.post<StateDTO>(State_update, data);
  }

  State_delete(data: StateDeleteRequestDTO): Observable<void> {
    return this.http.post<void>(State_delete, data);
  }

  State_ReadByID(data: StateReadByIdRequestDTO): Observable<StateDTO> {
    return this.http.post<StateDTO>(State_readById, data);
  }

  // States of one country only. Deliberately does NOT write into the shared states$
  // subject (State_ReadAll owns that), so callers get just their country's list.
  State_ReadByCountryId(data: StateReadByCountryIdRequestDTO): Observable<StateList> {
    return this.http.post<StateList>(State_readByCountryId, data);
  }

  State_ReadAll(): Observable<StateList> {
    return this.http.get<StateList>(State_readAll).pipe(tap(res => {
      if (res?.items) {
        this.states$.next(res.items.sort((a, b) => (a.stateName ?? '').localeCompare(b.stateName ?? '')));
      } else {
        this.states$.next([]); // Ensure next() is always called
      }
    }));;
  }
}
